/**
 * 英語翻訳ファイル（メイン言語）
 * MIBiGデータベースフロントエンド用
 */
export const en = {
  // ========================================
  // ナビゲーション
  // ========================================
  nav: {
    home: "Home",
    clusters: "Clusters",
    genes: "Genes",
    proteins: "Proteins",
    blast: "BLAST Search",
    reactions: "Reaction Search",
    substructure: "Substructure Search",
    fujisan: "FUJISAN",
    unkai: "UNKAI",
  },

  // ========================================
  // ホームページ
  // ========================================
  home: {
    title: "MIBiG Database",
    version: "BGC Proteins Database v3.0",
    heroTitle: "Biosynthetic Gene Cluster",
    heroSubtitle: "Database & Explorer",
    heroDescription: "Explore the comprehensive repository of biosynthetic gene clusters with advanced search, 3D protein visualization, and chemical structure analysis.",
    browseBtn: "Browse Clusters",
    blastBtn: "BLAST Search",
    statsTitle: "Database Statistics",
    featuresTitle: "Explore Features",
    quickSearch: "Quick Search",
    quickSearchDesc: "Use keyboard shortcut",
    quickSearchKey: "Ctrl+K",
    quickSearchHelp: "to open the command palette for quick navigation.",
    openPalette: "Open Command Palette",
  },

  // ========================================
  // 統計カード
  // ========================================
  stats: {
    clusters: "Gene Clusters",
    genes: "Genes",
    structures: "Protein Structures",
    compounds: "Compounds",
  },

  // ========================================
  // 機能カード
  // ========================================
  features: {
    clusterBrowser: {
      title: "Cluster Browser",
      description: "Browse and search biosynthetic gene clusters with advanced filtering",
    },
    blastSearch: {
      title: "BLAST Search",
      description: "Search sequences against PDB and SwissProt databases",
    },
    reactionSearch: {
      title: "Reaction Search",
      description: "Search enzymatic reactions using Rhea database",
    },
    substructureSearch: {
      title: "Substructure Search",
      description: "Find compounds by chemical substructure similarity",
    },
    explore: "Explore",
  },

  // ========================================
  // クラスターページ
  // ========================================
  cluster: {
    title: "Cluster List",
    filterBy: "Filters",
    biosynClass: "Biosynthetic Class",
    organism: "Organism",
    allClasses: "All Classes",
    allOrganisms: "All Organisms",
    search: "Search...",
    mibigAccession: "MIBiG Accession",
    organismName: "Organism Name",
    mainProduct: "Main Product",
    geneCount: "Gene Count",
    compounds: "Compounds",
    ncbiTaxId: "NCBI Taxonomy ID",
    mibigVersion: "MIBiG Version",
    noResults: "No clusters match your criteria.",
    loading: "Loading clusters...",
  },

  // ========================================
  // 遺伝子ページ
  // ========================================
  gene: {
    title: "Gene List",
    inCluster: "Genes in Cluster",
    product: "Product",
    proteinId: "Protein ID",
    uniprotLink: "UniProt Link",
    pdbHits: "PDB Hits",
    swissprotHits: "SwissProt Hits",
    domains: "Domains",
    sites: "Sites",
    viewProtein: "View Protein",
  },

  // ========================================
  // タンパク質ページ
  // ========================================
  protein: {
    title: "Protein Details",
    structure: "Predicted Structure",
    domains: "Conserved Domains",
    sites: "Functional Sites",
    pdbHits: "PDB BLAST Hits",
    swissprotHits: "SwissProt BLAST Hits",
    sequence: "Sequence",
    sequenceLength: "Sequence Length",
  },

  // ========================================
  // 構造ビューワー
  // ========================================
  structure: {
    selectModel: "Select Model",
    alphafold: "AlphaFold",
    colabfold: "ColabFold",
    colorBy: "Color Mode",
    colorPlDDT: "Color by plDDT",
    colorSecondary: "Color by Secondary Structure",
    colorAminoAcid: "Color by Amino Acid",
    wholeStructure: "Whole Structure",
    highlightDomain: "Highlight Domain",
    highlightSite: "Highlight Site",
    downloadPdb: "Download PDB",
  },

  // ========================================
  // ドメイン・サイト
  // ========================================
  domain: {
    pssmId: "PSSM ID",
    accession: "Accession",
    shortName: "Short Name",
    description: "Description",
    residueRange: "Residue Range",
    evalue: "E-value",
    siteType: "Site Type",
    residues: "Residues",
    sourceDomain: "Source Domain",
  },

  // ========================================
  // BLASTヒットテーブル
  // ========================================
  blast: {
    title: "BLAST Search",
    querySequence: "Query Sequence",
    database: "Database",
    submit: "Search",
    results: "Search Results",
    hit: "Hit",
    hsp: "HSP",
    pdbId: "PDB ID",
    chainId: "Chain",
    title_col: "Title",
    evalue: "E-value",
    identity: "Identity",
    coverage: "Coverage",
    accession: "Accession",
    recname: "Recommended Name",
    ligands: "Ligands",
    reactions: "Reactions",
    dbMibig: "MIBiG",
    dbPdb: "PDB",
    dbSwissprot: "SwissProt",
    dbCdd: "CDD",
  },

  // ========================================
  // 反応検索
  // ========================================
  reaction: {
    title: "Reaction Search",
    searchByCompound: "Search by Compound Name",
    searchPlaceholder: "Enter compound name...",
    rheaId: "Rhea ID",
    equation: "Reaction Equation",
    substrates: "Substrates",
    products: "Products",
    ecNumber: "EC Number",
    kegg: "KEGG",
    participants: "Reaction Participants",
  },

  // ========================================
  // 部分構造検索
  // ========================================
  substructure: {
    title: "Substructure Search",
    smartsPattern: "SMARTS Pattern",
    smartsPlaceholder: "Enter SMARTS pattern...",
    examples: "Examples:",
    benzene: "Benzene Ring",
    search: "Search",
    results: "Search Results",
    matchingCompounds: "Matching Compounds",
  },

  // ========================================
  // ChEBIテーブル
  // ========================================
  chebi: {
    chebiId: "ChEBI ID",
    count: "Count",
    bestEvalue: "Best E-value",
    name: "Name",
    formula: "Formula",
    pubchem: "PubChem",
    structure: "Structure",
  },

  // ========================================
  // タブラベル
  // ========================================
  tabs: {
    swissprotEntries: "SwissProt Entries",
    reactionParticipants: "Reaction Participants",
    pdbEntries: "PDB Entries",
    boundLigands: "Bound Ligands",
  },

  // ========================================
  // 共通UI
  // ========================================
  common: {
    loading: "Loading...",
    error: "An error occurred",
    noData: "No data available",
    notFound: "Not found",
    search: "Search",
    submit: "Submit",
    reset: "Reset",
    back: "Back",
    next: "Next",
    previous: "Previous",
    showMore: "Show More",
    showLess: "Show Less",
    download: "Download",
    copy: "Copy",
    copied: "Copied",
    externalLink: "External Link",
    viewDetails: "View Details",
    topResults: "Top {count} results",
    page: "Page",
    of: "of",
    items: "items",
  },

  // ========================================
  // エラーメッセージ
  // ========================================
  errors: {
    fetchFailed: "Failed to fetch data",
    notFound: "Resource not found",
    serverError: "Server error occurred",
    networkError: "Network error occurred",
    invalidInput: "Invalid input",
    timeout: "Request timed out",
    // New error messages for ApiError component
    unknown: "An unexpected error occurred",
    error: "Error",
    network: "Network Error",
    server: "Server Error",
    checkConnection: "Please check your internet connection and try again.",
    tryAgain: "Something went wrong. Please try again.",
    tryAgainLater: "The server is experiencing issues. Please try again later.",
    resourceNotFound: "The requested resource could not be found.",
  },

  // ========================================
  // パンくずナビ
  // ========================================
  breadcrumbs: {
    home: "Home",
    clusters: "Clusters",
    genes: "Genes",
    proteins: "Proteins",
    blast: "BLAST",
    reactions: "Reactions",
    substructure: "Substructure",
  },

  // ========================================
  // フッター
  // ========================================
  footer: {
    copyright: "© 2024 MIBiG Database",
    dataSources: "Data Sources",
    contact: "Contact",
  },

  // ========================================
  // データソース
  // ========================================
  dataSources: {
    mibig: "MIBiG (Biosynthetic Gene Clusters)",
    uniprot: "UniProt (Protein Sequences & Functions)",
    rhea: "Rhea (Biochemical Reactions)",
    chebi: "ChEBI (Chemical Entities)",
    pdb: "PDB (Protein Structures)",
    pubchem: "PubChem (Chemical Compounds)",
    alphafold: "AlphaFold (Protein Structure Predictions)",
    ncbiBlast: "NCBI BLAST+",
    cdd: "CDD (Conserved Domain Database)",
  },

  // ========================================
  // 生合成クラス
  // ========================================
  biosynClasses: {
    NRPS: "Nonribosomal Peptide Synthetase",
    PKS: "Polyketide Synthase",
    Terpene: "Terpene",
    RiPP: "Ribosomally Synthesized and Post-translationally Modified Peptide",
    Saccharide: "Saccharide",
    Alkaloid: "Alkaloid",
    Other: "Other",
  },

  // ========================================
  // クラスター詳細ページ
  // ========================================
  clusterDetail: {
    backToBrowser: "Back to Browser",
    backToClusterBrowser: "Back to Cluster Browser",
    clusterNotFound: "Cluster not found",
    viewOnMibig: "View on MIBiG",
    exportData: "Export Data",
    clusterInformation: "Cluster Information",
    biosyntheticClass: "Biosynthetic Class",
    ncbiTaxonomyId: "NCBI Taxonomy ID",
    mibigVersion: "MIBiG Version",
    geneCount: "Gene Count",
    genes: "Genes",
    compounds: "Compounds",
    noCompoundsRecorded: "No compounds recorded",
    viewDetails: "View Details",
    noDescription: "No description available",
    domains: "Domains",
    pdb: "PDB",
    swissprot: "SwissProt",
    fujisan: "FUJISAN",
    unkai: "UNKAI",
    noGenesFound: "No genes found for this cluster",
    proteinInteractionNetwork: "Protein Interaction Network",
    interactions: "interactions",
    clickNodeDescription: "Click protein nodes to view details. Click edges to view complex predictions.",
    showInteractionTable: "Show Interaction Table",
    hideInteractionTable: "Hide Interaction Table",
    type: "Type",
    protein1: "Protein 1",
    protein2: "Protein 2",
    ipSAE: "ipSAE",
    ipSAE_min: "ipSAE_min",
    ipTM: "ipTM",
    homo: "Homo",
    hetero: "Hetero",
    alphafold2Description: "AlphaFold2 multimer protein-protein interaction predictions. Only showing interactions with ipTM ≥ 0.6.",
  },

  // ========================================
  // タンパク質ビューアーページ
  // ========================================
  proteinViewer: {
    proteinNotFound: "Protein not found",
    backToCluster: "Back to Cluster {accession}",
    aminoAcids: "amino acids",
    ncbiProtein: "NCBI Protein",
    uniprot: "UniProt",
    downloadPdb: "Download PDB",
    structure3d: "3D Structure",
    loadingStructure: "Loading structure...",
    noStructureAvailable: "No structure available",
    blastHits: "BLAST Hits",
    pdbHits: "PDB Hits",
    swissprotHits: "SwissProt Hits",
    sequence: "Sequence",
    copy: "Copy",
    copied: "Copied!",
    noSequenceAvailable: "No sequence available",
    conservedDomains: "Conserved Domains",
    pssmId: "PSSM ID",
    accession: "Accession",
    shortName: "Short Name",
    residueRange: "Residue Range",
    evalue: "E-value",
    domainPositions: "Domain positions on sequence",
    functionalSites: "Functional Sites",
    siteType: "Site Type",
    residues: "Residues",
    sourceDomain: "Source Domain",
    downloadCoordinates: "Download Coordinates",
    models: "models",
    alphafold: "AlphaFold",
    colabfold: "ColabFold",
  },

  // ========================================
  // 複合体詳細ページ
  // ========================================
  complexDetail: {
    failedToLoadComplex: "Failed to load complex data",
    backToCluster: "Back to Cluster",
    proteinComplexPrediction: "Protein Complex Prediction",
    predictedInteraction: "Predicted interaction between {protein1} and {protein2}",
    predictionScores: "Prediction Scores",
    ipTM: "ipTM",
    ipTMDescription: "Interface predicted TM-score (higher is more confident)",
    ipSAE: "ipSAE",
    ipSAEDescription: "Interface pairwise alignment error score",
    ipSAE_min: "ipSAE_min",
    ipSAE_minDescription: "Minimum interface pairwise alignment error",
    interactionType: "Interaction Type",
    homodimer: "Homodimer",
    heterodimer: "Heterodimer",
    interactingProteins: "Interacting Proteins",
    protein1: "Protein 1",
    protein2: "Protein 2",
    viewProteinDetails: "View Protein Details",
    complexStructure: "Complex Structure",
    downloadPdb: "Download PDB",
    chainA: "Chain A ({protein})",
    chainB: "Chain B ({protein})",
    noStructureAvailable: "Complex structure coordinates are not yet available.",
    structureWillBeDisplayed: "The predicted complex model will be displayed here when available.",
    noComplexDataFound: "No complex data found for this protein pair.",
  },

  // ========================================
  // BLAST検索ページ
  // ========================================
  blastSearch: {
    title: "BLAST Search",
    description: "Search protein sequences against MIBiG, PDB, SwissProt, and CDD databases",
    submitSequence: "Submit Sequence",
    proteinSequence: "Protein Sequence (FASTA format)",
    loadExample: "Load Example",
    placeholder: "Paste your protein sequence in FASTA format...",
    targetDatabase: "Target Database",
    expectThreshold: "Expect Threshold (E-value)",
    maxTargetSequences: "Max Target Sequences",
    notApplicableForCdd: "Not applicable for CDD search",
    runBlastSearch: "Run BLAST Search",
    searchResults: "Search Results",
    runningBlastSearch: "Running BLAST search...",
    mayTakeMinutes: "This may take a few minutes depending on database size.",
    searchFailed: "Search Failed",
    unexpectedError: "An unexpected error occurred. Please try again.",
    foundHits: "Found {count} hits in {database} database",
    noSignificantHits: "No significant hits found. Try adjusting the E-value threshold.",
    mibigVsPdb: "MIBiG vs PDB (BLAST)",
    mibigVsSwissprot: "MIBiG vs SwissProt (BLAST)",
    rank: "#",
    mibig: "MIBiG",
    protein: "Protein",
    product: "Product",
    evalue: "E-value",
    identity: "Identity",
    coverage: "Coverage",
    pdbId: "PDB ID",
    chain: "Chain",
    title_col: "Title",
    ligands: "Ligands",
    name: "Name",
    ecNumbers: "EC Numbers",
    bitscore: "Bitscore",
    range: "Range",
    domainArchitecture: "Domain Architecture",
  },

  // ========================================
  // 反応検索ページ
  // ========================================
  reactionSearch: {
    title: "Reaction Search",
    description: "Search reaction participants to find related MIBiG gene clusters",
    searchReactionParticipants: "Search Reaction Participants",
    placeholder: "Search by compound name (e.g., ATP, NADH, acetyl-CoA)...",
    examples: "Examples:",
    compounds: "Compounds",
    chebiCompounds: "ChEBI Compounds",
    found: "found",
    structure: "Structure",
    chebiId: "ChEBI ID",
    formula: "Formula",
    noCompoundsFound: "No compounds found matching \"{term}\"",
    reactionsInvolving: "Reactions Involving",
    reactions: "Reactions",
    back: "Back",
    viewProteins: "View Proteins",
    noReactionsFound: "No reactions found for this compound.",
    mibigProteinsFor: "MIBiG Proteins for",
    proteins: "Proteins",
    reaction: "Reaction:",
    organism: "Organism",
    noProteinsFound: "No proteins found for this reaction.",
    aboutReactionSearch: "About Reaction Search",
    aboutDescription: "This tool allows you to navigate from reaction participants (ChEBI compounds) through Rhea reactions to MIBiG gene cluster proteins that catalyze these reactions.",
    navigationFlow: "Navigation Flow:",
    step1: "Search by compound name (e.g., \"ATP\")",
    step2: "Select a compound to view related reactions",
    step3: "Select a reaction to view catalyzing MIBiG proteins",
  },

  // ========================================
  // 部分構造検索ページ
  // ========================================
  substructureSearch: {
    title: "Substructure Search",
    description: "Search ChEBI compounds containing specific chemical substructures using SMARTS patterns",
    searchBySmartsExpression: "Search by SMARTS Expression",
    smartsPattern: "SMARTS Pattern",
    placeholder: "Enter SMARTS pattern (e.g., c1ccccc1 for benzene ring)",
    commonPatterns: "Common Patterns:",
    searchSubstructures: "Search Substructures",
    searching: "Searching for matching compounds...",
    mayTakeMoment: "This may take a moment for complex patterns.",
    searchFailed: "Search Failed",
    invalidSmartsPattern: "Invalid SMARTS pattern. Please check your expression.",
    matchingCompounds: "Matching Compounds",
    compoundsFound: "compounds found",
    noCompoundsFound: "No compounds found matching the SMARTS pattern. Try a simpler or more general substructure.",
    rheaReactions: "Rhea Reactions",
    mibigHits: "MIBiG Hits",
    pageOf: "Page {page} of {totalPages} ({total} total)",
    previous: "Previous",
    next: "Next",
    aboutSmartsSearch: "About SMARTS Substructure Search",
    aboutDescription: "This tool uses RDKit library to search for ChEBI compounds containing specified substructures. Results are linked to MIBiG biosynthetic gene clusters via Rhea reaction annotations.",
    smartsPatternExamples: "SMARTS Pattern Examples:",
    benzeneRing: "Benzene ring",
    carboxylicAcid: "Carboxylic acid",
    sixMemberedRing: "6-membered carbon ring",
    primaryAmine: "Primary amine",
  },

  // ========================================
  // PDBヒットページ
  // ========================================
  pdbHitsPage: {
    backTo: "Back to {protein}",
    pdbBlastHits: "PDB BLAST Hits",
    domain: "Domain {start}-{end}",
    fromCluster: "from cluster",
    hitsFound: "PDB hits found",
    pdbEntries: "PDB Entries",
    boundLigands: "Bound Ligands",
    rank: "#",
    pdbId: "PDB ID",
    chain: "Chain",
    title: "Title",
    evalue: "E-value",
    identity: "Identity",
    coverage: "Coverage",
    structure: "Structure",
    ligandId: "Ligand ID",
    name: "Name",
    formula: "Formula",
    pdb: "PDB",
    pubchem: "PubChem",
    noBoundLigands: "No bound ligands found in PDB hits",
  },

  // ========================================
  // SwissProtヒットページ
  // ========================================
  swissprotHitsPage: {
    failedToLoad: "Failed to load SwissProt hits",
    backToProtein: "Back to Protein",
    swissprotBlastHits: "SwissProt BLAST Hits",
    domain: "Domain {start}-{end}",
    fromCluster: "from cluster",
    hitsFound: "SwissProt hits found",
    filteredByReaction: "Filtered by reaction: {rheaAccession}",
    swissprotEntries: "SwissProt Entries",
    reactions: "Reactions",
    rank: "#",
    accession: "Accession",
    name: "Name",
    evalue: "E-value",
    identity: "Identity",
    coverage: "Coverage",
    ecNumbers: "EC Numbers",
    kegg: "KEGG",
    cofactors: "Cofactors",
    noSwissprotHits: "No SwissProt hits found",
    rheaId: "Rhea ID",
    equation: "Equation",
    swissprot: "SwissProt",
    noReactionsFound: "No reactions found in SwissProt hits",
    chebiCompounds: "ChEBI Compounds",
  },

  // ========================================
  // データソースページ
  // ========================================
  dataSourcesPage: {
    title: "Data Sources",
    description: "Information about databases and resources used in this application",
    mibigVersion: "Gene cluster information is based on MIBiG version 4.0",
    lastUpdated: "Last updated: November 15, 2024",
    externalDatabases: "External Databases",
    visit: "Visit",
    download: "Download",
    precomputedBlast: "Precomputed BLAST Results",
    precomputedDescription: "All BLAST results in this database are precomputed and stored for fast retrieval. The following datasets are available:",
    rows: "rows",
    bulkDownloads: "Bulk Downloads",
    bulkDescription: "BLAST search results stored in this database are available for download in tab-separated values (TSV) format.",
    searchAndBrowse: "Search and Browse Options",
    byMibigAccession: "By MIBiG Accession",
    byMibigAccessionDesc: "Search gene clusters using MIBiG accession numbers (e.g., BGC0000001)",
    byProteinId: "By Protein ID",
    byProteinIdDesc: "Search genes by NCBI protein identifier or locus tag",
    byCompoundName: "By Compound Name",
    byCompoundNameDesc: "Search reaction participants by compound name with wildcard support",
    bySubstructure: "By Substructure",
    bySubstructureDesc: "Search compounds by substructure matching using SMARTS expressions",
    blastSearch: "BLAST Search",
    blastSearchDesc: "Search MIBiG, PDB, SwissProt, and CDD databases with custom sequences",
    browseClusters: "Browse Clusters",
    browseClustersDesc: "Browse all gene clusters with filtering by biosynthetic class and organism",
    developedBy: "Developed By",
    affiliation1: "Computational Biology Lab, Department of Biotechnology, Graduate School of Agricultural and Life Sciences, The University of Tokyo",
    affiliation2: "Laboratory of Computational Drug Design, Graduate School of Medical and Dental Sciences, Institute of Science Tokyo",
    affiliation3: "Mechanical Engineering (Mechatronics), Graduate School, University of Yamanashi",
  },

  // ========================================
  // 404ページ
  // ========================================
  notFoundPage: {
    title: "404",
    heading: "Page Not Found",
    description: "The page you are looking for does not exist or has been moved. Please check the URL or return to the homepage.",
    goBack: "Go Back",
    home: "Home",
  },

  // ========================================
  // コマンドパレット
  // ========================================
  commandPalette: {
    placeholder: "Search clusters, proteins, sequences, compounds...",
    quickNavigation: "Quick Navigation",
    recentlyVisited: "Recently Visited",
    recentSearches: "Recent Searches",
    actions: "Actions",
    compounds: "Compounds",
    pages: "Pages",
    clusters: "Clusters",
    proteins: "Proteins",
    searching: "Searching...",
    noResults: "No results found for \"{query}\"",
    typeToSearch: "Type at least 2 characters to search",
    navigate: "Navigate",
    select: "Select",
    close: "Close",
    sequenceDetected: "Sequence detected - Run BLAST search",
    smartsDetected: "SMARTS pattern detected - Search chemical structures",
    compoundDetected: "Compound/enzyme detected - Search reactions",
    mibigAccessionDetected: "MIBiG accession detected",
    searchClustersProteins: "Search clusters and proteins",
    goToHomepage: "Go to homepage",
    browseAllClusters: "Browse all gene clusters",
    sequenceSimilaritySearch: "Sequence similarity search",
    searchBiochemicalReactions: "Search biochemical reactions",
    chemicalSubstructureSearch: "Chemical substructure search",
    recentSearch: "Recent search",
    searchCompoundsReactions: "Search compounds and biochemical reactions",
  },

  // ========================================
  // 相互作用ネットワーク
  // ========================================
  interactionNetwork: {
    noInteractionsFound: "No protein interactions found",
    zoomIn: "Zoom In",
    zoomOut: "Zoom Out",
    fitToView: "Fit to View",
    proteinClickToView: "Protein (click to view)",
    ipTMHigh: "ipTM ≥ 0.9 (high)",
    ipTMMedium: "ipTM 0.75-0.9",
    ipTMLow: "ipTM 0.6-0.75",
    edgeLabelsShowIpTM: "Edge labels show ipTM values",
    clickEdgeForDetails: "Click edge for complex details",
  },

  // ========================================
  // ヘッダー
  // ========================================
  header: {
    database: "Database",
    toggleLanguage: "Toggle Language",
    toggleTheme: "Toggle Theme",
  },

  // ========================================
  // フッター（拡張）
  // ========================================
  footerExtended: {
    developedBy: "Developed by",
    universityOfTokyo: "University of Tokyo",
    instituteOfScienceTokyo: "Institute of Science Tokyo",
    universityOfYamanashi: "University of Yamanashi",
    dataSources: "Data sources: MIBiG v4.0 (Nov 2024), SwissProt 2024_06, AlphaFold v4, Rhea 136",
    viewAllDataSources: "View all data sources",
  },
};

export type Translations = typeof en;
